import ReactDOM from 'react-dom';
import { FC, ReactNode, useContext } from 'react';
import ThemeContext from '../../contexts/themeContext';

interface IPortalProps {
	children: ReactNode;
	// defaulted via destructuring below, no need for defaultProps
	id?: string;
}

const Portal: FC<IPortalProps> = ({ id = 'portal-root', children }) => {
	const { fullScreenStatus } = useContext(ThemeContext);

	// if app is in full-screen mode, render children directly
	if (fullScreenStatus) return <>{children}</>;

	// otherwise try to portal into the given DOM node
	const mountNode = document.getElementById(id);
	if (mountNode) {
		return ReactDOM.createPortal(children, mountNode);
	}

	return null;
};

export default Portal;
